import React, { useState } from "react";
import InputBox from "../../Component/UI/InputBox";
import AddButton from "../../Component/UI/AddButton";
import ReactSelect from "../../Component/UI/ReactSelect"
import { MdCheckCircle, MdOutlineCircle } from "react-icons/md";
import { MdSearch, MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import CommonTableCheckbox from "../../../AdminPanel/Component/UI/CommonTableCheckbox";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { LuSend } from "react-icons/lu";
import { AiOutlinePlus } from "react-icons/ai";

export default function AddCampaignsModal({ onClose }) {

  const [hovered, setHovered] = useState(null);

  const cards = [
    {
      id: "talent28",
      title: "TalentPlusStrengths 28",
      desc: "Available Codes: 9",
    },
    {
      id: "top5",
      title: "Top 5 TalentPlusStrengths",
      desc: "Available Codes: 7",
    },
    {
      id: "top5teen",
      title: "Top 5 Teen TalentPlusStrengths",
      desc: "Available Codes: 3",
    },
    {
      id: "teencareer",
      title: "Teen Career Guidance",
      desc: "Available Codes: 5",
    },
  ];

  const fields = [
    { label: "Campaign Name*", name: "campaignname*" },
  ];
  const fields2 = [
    { label: "Email Subject*", name: "emailsubject*" },
  ];


  const [form, setForm] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const colourOptions = [
    { value: 'team1', label: 'Team1' },
    { value: 'team2', label: 'Team2' },
    { value: 'team3', label: 'Team3' },
    { value: 'team4', label: 'Team4' },
  ];


  // if (!isOpen) return null;
  const data = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    name: "Aarav Sharma",
    email: "aarav.sharma@companydemo.in",
    // role: i === 9 ? "Admin" : "User",
  }));

  const columns = [
    { key: "id", label: "S.No." },
    { key: "name", label: "Name" },
    { key: "email", label: "Email Address" },
    // { key: "role", label: "Role" },
  ];

  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Modal Container section 1 */}
      {/* <div className="relative bg-white w-full max-w-3xl rounded-2xl p-8 z-10">
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-1">Create Campaign</h2>
          <p className="text-sm textlight">Compose your email campaign in two simple steps</p>
        </div>

        <div className="flex items-center gap-4 mb-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bgcolor text-white flex items-center justify-center text-sm font-semibold">1</div>
            <span className="text-sm font-medium textcolor">Compose Email</span>
          </div>
          <div className="flex-1 h-[6px] bg-[#D9D9D9]" />
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[#D9D9D9] textlight flex items-center justify-center text-sm font-semibold">2</div>
            <span className="text-sm font-medium textlight">Select Recipients</span>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            {fields.map(({ label, name }) => (
              <InputBox
                key={name}
                label={label}
                name={name}
                value={form[name]}
                onChange={handleChange}
              />
            ))}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium">Recipients Type*</label>
              <ReactSelect
                name="role"
                value={form.role}
                options={colourOptions}
                onChange={handleChange}
                placeholder="Select role"
              />
            </div>
            <div>
              <label className="text-sm font-medium">Choose Team*</label>
              <ReactSelect
                name="role"
                value={form.role}
                options={colourOptions}
                onChange={handleChange}
                placeholder="Select role"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Assessment Types</label>
            <div className="grid grid-cols-2 gap-4">
              {cards.map(({ id, title, desc, icon: Icon }) => {
                const active = hovered === id;
                return (
                  <div
                    key={id}
                    onMouseEnter={() => setHovered(id)}
                    onMouseLeave={() => setHovered(null)}
                    className={`px-4 py-2 rounded-md flex items-center justify-between cursor-pointer border transition-all
              ${active
                        ? "border-[#009688] bg-[#E0F2F180]"
                        : "border-gray-200 bg-gradient-to-r from-[#FFFFFF] to-[#E0F2F1]"
                      }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex items-center justify-center">
                        {active ? (
                          <MdCheckCircle size={22} className="text-[#009688]" />
                        ) : (
                          <MdOutlineCircle size={22} className="text-[#D9D9D9]" />
                        )}
                      </div>
                      <div>
                        <p className="text-base">{title}</p>
                        <p className="text-sm textlight">{desc}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            {fields2.map(({ label, name }) => (
              <InputBox
                key={name}
                label={label}
                name={name}
                value={form[name]}
                onChange={handleChange}
              />
            ))}
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Email Message
            </label>
            <textarea
              placeholder="Write your message here..."
              rows={2}
              className="mt-0.5 w-full border rounded-md px-4 py-2 focus:ring-1 focus:ring-[#009688] outline-none disabled:bg-gray-100"
            />
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-6">
          <button onClick={() => onClose()} className="px-6 py-2 border rounded-md">Cancel</button>
          <AddButton title="Next: Select Recipients" className="bgcolor text-white px-6" />
        </div>
      </div> */}

      {/* Modal Container section 2 */}
      {/* <div className="relative bg-white w-full max-w-3xl rounded-2xl p-8 z-10">
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-1">Create Campaign</h2>
          <p className="text-sm textlight">Compose your email campaign in two simple steps</p>
        </div>
        <div className="flex items-center gap-4 mb-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bgcolor text-white flex items-center justify-center text-sm font-semibold">1</div>
            <span className="text-sm font-medium textcolor">Compose Email</span>
          </div>
          <div className="flex-1 h-[6px] bgcolor" />
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bgcolor text-white flex items-center justify-center text-sm font-semibold">2</div>
            <span className="text-sm font-medium textcolor">Select Recipients</span>
          </div>
        </div>

        <div className="px-6 py-4">
          <div className="border rounded-lg overflow-hidden">
            <div className="flex justify-between items-center px-4 pt-4 pb-2">
              <div className="flex items-center gap-2 text-sm text-black">
                Show
                <select className="border rounded-md px-2 py-1">
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                entries
              </div>

              <div className="flex items-center gap-3 text-sm text-black">
                <div className="relative">
                  <MdSearch size={22} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input type="text" placeholder="Search" className="w-56 pl-9 pr-3 py-2 border border-[#D9D9D9] textlight rounded-md text-sm focus:outline-none" />
                </div>

                <div>1–20 of 150</div>
                <div className="p-2 rounded-md bg-gray-200 text-teal-600">
                  <MdArrowBackIos size={20} />
                </div>
                <div className="p-2 rounded-md bg-gray-200 text-teal-600">
                  <MdArrowForwardIos size={20} />
                </div>
              </div>
            </div>
            <div className="max-h-[260px] overflow-auto">
              <div className="overflow-x-auto bg-white p-4">
                <CommonTableCheckbox
                  columns={columns}
                  data={data}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-6">
          <button onClick={() => onClose()} className="px-6 py-2 border rounded-md">Previous</button>
          <AddButton title="Send Campaign" Icon={LuSend} className="bgcolor text-white px-6" />
        </div>
      </div> */}

      {/* Modal Container section 3 */}
      <div className="relative bg-white w-full max-w-xl rounded-2xl p-8 z-10">

        <div class="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full">
          <img src="/admindashboard/Frame 18308.svg" alt="" />
        </div>

        <h2 class="text-center text-2xl font-semibold textblack">Email Sent Successfully</h2>

        <p class="mt-2 text-center text-sm textlight">
          Your campaign email has been delivered to the selected recipients.
        </p>

        <div class="mt-6 rounded-xl bg-[#F9FAFB] p-5 space-y-4">
          <div class="flex text-sm">
            <span class="textlight w-44">Campaign</span>
            <span class="font-medium textblack text-right">Happiest Workplaces Awards 2025</span>
          </div>

          <div class="flex text-sm">
            <span class="textlight w-44">Recipients</span>
            <span class="font-medium textblack text-right">1,250 users</span>
          </div>

          <div class="flex text-sm">
            <span class="textlight w-44">Sent On</span>
            <span class="font-medium textblack text-right">08 Jan 2026, 11:45 AM</span>
          </div>
        </div>

        <div className="flex justify-center items-center gap-4 mt-6">
          <button onClick={() => onClose()} className="px-6 py-2 border rounded-md">View Campaign</button>
          <AddButton title="Create New Campaign" Icon={AiOutlinePlus} className="bgcolor text-white px-6" />
        </div>

      </div>
    </div>
  );
}
